import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProvider as PolarisProvider } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';
import '@shopify/polaris/build/esm/styles.css';
import { App } from './App';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

// Shopify passes a `host` query param when loading this app inside Shopify Admin.
// Outside of that context (e.g. visiting staff.herbanvault.com directly in a
// browser tab), host is absent and we render in "standalone" mode for local UI dev.
//
// App Bridge integration lands in Session 2 when we need session tokens to call
// our spine API as the verified Shopify staff user. The Polaris shell here is
// enough for the embed iframe to render correctly inside Shopify Admin.
const standalone = new URLSearchParams(window.location.search).get('host') === null;

createRoot(container).render(
  <StrictMode>
    <PolarisProvider i18n={enTranslations}>
      <App standalone={standalone} />
    </PolarisProvider>
  </StrictMode>,
);
